import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
const state = {
  corporationID: 0,
  corporationName: ''
};
const mutations = {
  SET_CORPORATION_ID: (state, id) => {
    state.corporationID = id;
  },
  SET_CORPORATION_NAME: (state, name) => {
    state.corporationName = name;
  },
  SET_CORPORATION: (state, data) => {
    state = _Object$assign(state, data);
  }
};
const actions = {
  updateTransactionCorporation({
    commit
  }, data) {
    commit('SET_CORPORATION_ID', data.id);
    commit('SET_CORPORATION_NAME', data.name);
    commit('SET_CORPORATION', data);
  }
};
export default {
  namespaced: true,
  state,
  mutations,
  actions
};